export default __webpack_public_path__ + "static/media/show.395b21fa.svg";